import React, { useState, useEffect } from "react";
// import { getDay, getTimestring } from "../../functions/index";

const PerkCard = ({ item, id }) => {
  const { startTime, endTime } = item;
  const startStr = new Date(startTime).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  });
  const endStr = new Date(endTime).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  });
  return (
    <div className="perk-card" key={id}>
      <div
        style={{ backgroundImage: `url(${item.perkLogo})` }}
        className="background"
      />
      <p className="perk-item-title mt-1">{item.perkName}</p>
      <p className="perk-item-title mt-auto">
        {startStr} - {endStr}
      </p>
    </div>
  );
};
export default PerkCard;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/PerkCard.js